module.exports = "/_next/static/images/credit_card-d86a71a32c0d7f0795b58a7594a04fb2.svg";